import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EMPLOYERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deleteEmployerDiscountAction = createAsyncThunk(
    'benefit/deleteEmployerDiscountAction',
    async (employerId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ EMPLOYERS_PATH }/${ employerId }/discounts`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteEmployerDiscountSlice = createSlice({
    name: 'deleteEmployerDiscountSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteEmployerDiscountAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteEmployerDiscountAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteEmployerDiscountAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteEmployerDiscountState = (state) => state.benefit.deleteEmployerDiscount;
export default deleteEmployerDiscountSlice.reducer;
